import { format, isValid, parseISO, parseJSON } from 'date-fns';

export const parseServerDateFormat = (format?: string) => (format ? format.replace(/mm/, 'MM') : 'yyyy-MM-dd');

export const convertServerDateTimeString = (dateString: string, settingsDateFormat?: string): string => {
  const date = parseISO(dateString);

  return isValid(date) ? format(parseJSON(dateString), `${parseServerDateFormat(settingsDateFormat)} HH:mm:ss`) : '';
};
